import React, { useState } from "react";
import { Input, Button, Form, Row, Col } from "antd";
import { toAddProjectNote } from "../apis/actions/dashboard.actions";
import ModalComponent from "../components/ModalComponent";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../apis/store";
import { showNotitfication } from "../domains/Hooks";
interface AddProjectNoteModalProps {
  visible: boolean;
  onClose: () => void;
  ProjectId: string | null;
  ProjectName: string | null;
}

function AddProjectNoteModal({
  visible,
  onClose,
  ProjectId,
  ProjectName,
}: AddProjectNoteModalProps) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const handleAddNote = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const note = form.getFieldValue("note");
      const addNoteData = {
        project_id: ProjectId,
        note: note,
      };
      dispatch(toAddProjectNote(addNoteData)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setLoading(false);
          form.resetFields();
          onClose();
        } else {
          showNotitfication(response?.message, "error");
          setLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalComponent
      destroyOnClose
      title=""
      open={visible}
      onClose={() => onClose()}
      closeOnOutsideClick={true}
      width={500}
      modalStyle={{ top: 200 }}
    >
      <Row justify={"center"}>
        <p className="ghaith--confirm-logout" style={{ direction: "rtl" }}>
          إرفاق ملاحظة تخص المشروع : {ProjectName}{" "}
        </p>
      </Row>
      <Form form={form}>
        <Row
          gutter={16}
          justify={"center"}
          style={{ paddingTop: "2rem" }}
          className={`ghaith--content-profile-box1`}
        >
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <Form.Item
              name="note"
              label="الملاحظة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "ghaith--label-style" }}
              validateTrigger="onBlur"
            >
              <Input.TextArea rows={4} placeholder="أدخل الملاحظة هنا..." />
            </Form.Item>
          </Col>
        </Row>
        <Row
          justify={"end"}
          dir="rtl"
          style={{ width: "100%", paddingTop: "1rem" }}
        >
          <Button
            className="ghaith--cancel-btn-logout ghaith--send-button"
            onClick={handleAddNote}
            title="إرسال"
            disabled={loading}
          >
            إرسال
          </Button>
        </Row>
      </Form>
    </ModalComponent>
  );
}

export default AddProjectNoteModal;
